import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=2c3f6e1e&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"
import style0 from "./Legal.vue?vue&type=style&index=0&id=2c3f6e1e&prod&scoped=true&lang=css"
import style1 from "./Legal.vue?vue&type=style&index=1&id=2c3f6e1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f6e1e",
  null
  
)

export default component.exports